import ColorThief, { Color } from 'color-thief-browser';

import Model from '../Model';
import stringToColor from '../utils/stringToColor';
import ItemList from '../utils/ItemList';
import computed from '../utils/computed';
import GroupBadge from '../components/GroupBadge';
import Mithril from 'mithril';
import Group from './Group';
import ActivityTag from './ActivityTag';

export default class ActivityReward extends Model {
  tag() {
    return Model.attribute<string>('tag').call(this);
  }
  name() {
    return Model.attribute<string>('name').call(this);
  }
  level() {
    return Model.attribute<number>('level').call(this);
  }
  levelCount() {
    return Model.attribute<number>('levelCount').call(this);
  }
  emailTitle() {
    return Model.attribute<string>('emailTitle').call(this);
  }
  emailText() {
    return Model.attribute<string>('emailText').call(this);
  }
  goods() {
    return Model.attribute<string>('goods').call(this);
  }
}
